// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2D7x5","loader":"style_loader__d7YnB","pre-loader-icon":"style_pre-loader-icon__2FtsD"};